import axios from '@/libs/api.request'
import {downloadFile} from "./data";

export const addSelfCheckTask = (form,auth) => {
  const data = {...form}
  return axios.request({
    url:'/api/api_v1.0/selfCheck/add.json',
    data,
    method:'post',
    headers:{'Authorization':auth},
  })
}

export const updateSelfCheckTask = (form, auth) => {
  const data = {...form}
  return axios.request({
    url:'/api/api_v1.0/selfCheck/update.json',
    data,
    method:'post',
    headers:{'Authorization':auth},
  })
}

export const deleteSelfCheck = (id, auth) => {
  const params = {id:id}
  return axios.request({
    url:'/api/api_v1.0/selfCheck/delete.json',
    params,
    method:'get',
    headers:{'Authorization':auth},
  })
}


export const getAllSelfChecksForPage = (param)=>{
  return axios.request({
    url:'/api/api_v1.0/selfCheck/queryAll.json',
    data:param,
    method:'post',
  })
}

export const getSelfCheckDetail = (id,auth)=> {
  const params = {id: id}
  return axios.request({
    url: '/api/api_v1.0/selfCheck/getDetail.json',
    params,
    method: 'get',
    headers: {'Authorization': auth},
  })
}

export const getSelfCheckResultForPage = (params)=>{
  return axios.request({
    url:'/api/api_v1.0/selfCheck/getResultForPage.json',
    data:params,
    method:'post',
  })
}

export const getSelfCheckResultByExtensForPage = (params)=>{
  return axios.request({
    url:'/api/api_v1.0/selfCheck/getResultByExtensForPage.json',
    data:params,
    method:'post',
  })
}

export const getSelfCheckHistoryResultForPage = (param)=>{
  return axios.request({
    url:'/api/api_v1.0/selfCheck/history/resultForPage.json',
    data:param,
    method:'post',
  })
}

export const getSelfCheckHistoryResultByExtensForPage = (param)=>{
  return axios.request({
    url:'/api/api_v1.0/selfCheck/history/resultByExtensForPage.json',
    data:param,
    method:'post',
  })
}

export const setStatus = (id,status) =>{
  const data = {id,status}
  return axios.request({
    url:'/api/api_v1.0/selfCheck/setStatus.json',
    data,
    method:'post'
  })
}

export const downloadResult = (params) =>{
  let options = {
    url:'/api/api_v1.0/selfCheck/exportList.json',
    method:'post',
    data:params,
  }
  downloadFile(options)
}



// WEBPACK FOOTER //
// ./src/api/selfCheck.js